import React from 'react';
import uuidv4 from 'uuid';

import PropTypes from 'prop-types';
import update from 'immutability-helper';

import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';

//import InputLabel from '@material-ui/core/InputLabel';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import CircularProgress from '@material-ui/core/CircularProgress';

//comopnents:
import NeuriteGrid from '../../neurite_grid';
import DatePicker from '../../utils/DatePicker';

//helpers:
import { getData, putData, postData, createReport } from '../../../dataLib';

import FloatNumberFormatInput from '../../../components/float_number_input_formatter';


const styles = theme => ({
    root: {
        // height: '100%',
        // width: 240
        flexGrow: 1,
    },
    containerPair: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: 700,
    },
    formControl: {
        display: 'flex',
        justifyContent: 'center',
        //margin: '5px 25px',
        minWidth: 120,
        //height: 72,
    },
    buttonsContainer: {
        width: 700,
        padding: '25px 0 0 25px',
    },
    buttonsBottom: {
        marginRight: 15,
        padding: '10px 4%',
        borderRadius: 0,
        textTransform: 'capitalize',
        color: 'white',
        border: 'none',
        boxShadow: 'none',
    },
    formComent: {
        display: 'flex',
        justifyContent: 'center',
        margin: '10px 0 5px 25px',
        width: 520,
        minWidth: 120,
    },
});

class EditNuevoAlbaran extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            pedido_id: this.props.pedido.id,
            centro_id: this.props.centroId,
            centroDescr: this.props.centroDescr,
            proveedorDescr: this.props.pedido.proveedorDescr,
            fDoc: this.props.pedido.fDoc,
            documento: this.props.pedido.refPedido,
            obsv: this.props.pedido.obsv,
            showSpinner: true,
            a_refAlbaran: '', // <=> albaran.refAlbaran
            a_iTipoAlbaran: 0, // <=> albaran.iTipoAlbaran
            a_fEntrega: new Date().toISOString().slice(0, 10), // <=> albaran.fEntrega
            a_obsv: '', // <=> albaran.obsv
            albaran: {},
            tot_albaran: 0.0,
            tot_uds: 0,
        };
    }

    componentDidMount() {
        // obtiene un nuevo albarán
        let URL = (this.props.imenu === "1" ?
            'DCAlbarans/pendiente?pedido_id='
            :
            'DCAlbarans/'
        ) + this.props.pedido.id;

        this.setState({ ...this.state, showSpinner: true });
        getData(
            URL,
            response => {
                // añadea a cada fila del inventario un campo para el contro del color
                // de las columnas
                response.data.lLineas = response.data.lLineas.map(p => {
                    return { ...p, colColorTrue: true };
                });

                const udsArray = response.data.lLineas.map(row => row.cantidad);
                const totalArray = response.data.lLineas.map(row => row.total);

                this.setState({
                    ...this.state,
                    albaran: response.data,
                    tot_uds: udsArray.length ? udsArray.reduce((a, b) => a + b) : 0,
                    tot_albaran: totalArray.length ? totalArray.reduce((a, b) => a + b) : 0,
                    showSpinner: false,
                    a_fEntrega: response.data.fEntrega ? response.data.fEntrega.slice(0, 10) : new Date().toISOString().slice(0, 10)
                });
            },
            error => {
                this.props.openDialog(
                    'SimpleMessage',
                    {
                        message: 'ERROR fetching pedido',
                    },
                    'ent_nuevo_albaran',
                    false,
                    'sm',
                );
                this.setState({ ...this.state, showSpinner: false });
            },
            this.props.user,
        );
    }

    handleValueChange = (event, field) => {
        this.setState({ ...this.state, [field]: event.target.value });
    };
    handleValueChangeDate = (event, field) => {
        this.setState({ ...this.state, [field]: event });
    };

    handleCheckboxNumber = (e, field) => {
        const value = e.target.checked;

        this.setState({ ...this.state, [field]: value ? 1 : 0 });
    };


    nuevoAlbaran_hideDialog = () => {
        // Verifica que tenga la referencia
        if (!this.state.a_refAlbaran || this.state.a_refAlbaran === '') {
            this.props.openDialog(
                'SimpleMessage', { message: 'La referencia del albarán no puede ser nula' }, uuidv4(), false, 'sm',
            );
        }
        else {
            // Calcula previamente cuanto se ha introducido de forma valorada
            let total = 0.0;
            this.state.albaran.lLineas.forEach(r => {
                if (r.cantidad !== null && r.precio !== null)
                    total += parseFloat(r.cantidad) * parseFloat(r.precio);
            });

            // genera un nuevo albarán con todas la lista de lineas
            this.setState(
                {
                    ...this.state,
                    albaran: {
                        ...this.state.albaran,
                        refAlbaran: this.state.a_refAlbaran,
                        iTipoAlbaran: this.state.a_iTipoAlbaran,
                        fEntrega: this.state.a_fEntrega,
                        obsv: this.state.a_obsv,
                    },
                    showSpinner: true,
                },
                () => {
                    postData(
                        'DCAlbarans/' + this.state.centro_id,
                        response => {
                            this.setState({ ...this.state, showSpinner: false });
                            this.props.okHandler(total);
                            this.props.hideDialog();
                        },
                        error => {
                            this.props.openDialog(
                                'SimpleMessage',
                                {
                                    message:
                                        'Error generando nuevo albarán: ' +
                                        error.response.data,
                                },
                                uuidv4(),
                                false,
                                'sm',
                            );
                            this.setState({ ...this.state, showSpinner: false });
                        },
                        this.state.albaran,
                        this.props.user,
                    );
                },
            );
        }
    };

    handleGridRowsUpdated = ({ fromRow, toRow, fromRowData, updated }) => {

        console.log(fromRowData);

        if (fromRow !== toRow || fromRowData.iCantidadPendiente === null) return; //solo modificamos una fila

        // const nuevaLista = this.state.albaran.lLineas.slice();
        // for (let i = fromRow; i <= toRow; i++) {
        //     let updatedRow = update(this.state.albaran.lLineas[i], {
        //         $merge: updated,
        //     });
        //     nuevaLista[i] = updatedRow;
        // }

        const nuevaLista = this.state.albaran.lLineas.slice();
        let updatedRow = update(this.state.albaran.lLineas[fromRowData.grid_index], {
            $merge: updated,
        });
        nuevaLista[fromRowData.grid_index] = updatedRow;

        const udsArray = nuevaLista.map(row => row.cantidad == null ? 0 : parseInt(row.cantidad));
        const totalArray = nuevaLista.map(row => row.cantidad == null || row.precio == null ? 0 : parseFloat(row.cantidad) * row.precio);

        this.setState({
            ...this.state,
            albaran: { ...this.state.albaran, lLineas: nuevaLista },
            tot_uds: udsArray.length ? udsArray.reduce((a, b) => a + b) : 0,
            tot_albaran: totalArray.length ? totalArray.reduce((a, b) => a + b) : 0,
        });
    };


    imprimir = () => {

        this.setState({ ...this.state, showSpinner: true });

        const win = window.open(process.env.PUBLIC_URL + '/loading_report.html', '_blank');

        let url = '';

        createReport(
            {
                reportDefinition: { id: 59 },
                values: {
                    centroId: this.props.centroId,
                    maquinaId: this.props.pedido.id,
                    page: -1
                }
            },
            "PDF",
            this.props.user, '')
            .then(response => {
                url = window.URL.createObjectURL(new Blob([response.data], { type: "application/pdf" }));
                win.location.href = url;
            }).catch(error => {
                this.props.openDialog('SimpleMessage', {
                    message: 'ERROR generating PDF'
                }, 'error-opem-report-pdf', false, false);
            }).then(() => {
                this.setState({ ...this.state, showSpinner: false });
            });
    };


    borrarAlbaran = () => {

        let url = 'DCAlbarans/borrar?albaran_id=' + this.state.albaran.id;

        this.setState({ ...this.state, showSpinner: true }, () => {

            putData(url, (response) => {

                this.setState({ ...this.state, showSpinner: false });

                this.props.hideDialog();

                if (this.props.refreshHandler !== undefined) this.props.refreshHandler();

                this.props.openDialog(
                    'SimpleMessage',
                    {
                        message: 'Albaran eliminado',
                    },
                    'borrar_albaran_hist_success',
                    false,
                    'sm',
                );

            }, (error) => {
                this.props.openDialog(
                    'SimpleMessage',
                    {
                        message: 'Error eliminando albaran, compruebe que no hay inventarios posteriores cerrados',
                    },
                    'borrar_albaran_hist_error',
                    false,
                    'sm',
                );
                this.setState({ ...this.state, showSpinner: false });
            }, {}, this.props.user, false);
        });

    }

    abrirAlbaran = () => {

        let url = 'DCAlbarans/abrir?albaran_id=' + this.state.albaran.id;

        this.setState({ ...this.state, showSpinner: true }, () => {

            putData(url, (response) => {

                const newAlbaran = { ...this.state.albaran, bCerrado: false }

                this.setState({ ...this.state, albaran: newAlbaran, showSpinner: false });

            }, (error) => {
                this.props.openDialog(
                    'SimpleMessage',
                    {
                        message: 'Error abriendo albaran, compruebe que no hay inventarios posteriores cerrados',
                    },
                    'borrar_albaran_hist_error',
                    false,
                    'sm',
                );
                this.setState({ ...this.state, showSpinner: false });
            }, {}, this.props.user, false);
        });

    }

    actualizarAbaran_hideDialog = () => {

        this.setState({ ...this.state, showSpinner: true }, () => {

            putData(
                'DCAlbarans/' + this.state.centro_id,
                response => {

                    this.setState({ ...this.state, showSpinner: false });

                    this.props.hideDialog();

                    if (this.props.refreshHandler !== undefined) this.props.refreshHandler();

                    this.props.openDialog(
                        'SimpleMessage',
                        {
                            message: 'Albaran modificado',
                        },
                        'modificar_albaran_hist_success',
                        false,
                        'sm',
                    );

                },
                error => {
                    this.props.openDialog(
                        'SimpleMessage',
                        {
                            message:
                                'Error modificando albarán: ' +
                                error.response.data,
                        },
                        'error_modificando_albaran',
                        false,
                        'sm',
                    );

                    this.setState({ ...this.state, showSpinner: false });

                },
                { ...this.state.albaran, fEntrega: this.state.a_fEntrega },
                this.props.user,
            );
        });

    }

    cerrarAbaran_hideDialog = () => {
        let url = 'DCAlbarans/cerrar?albaran_id=' + this.state.albaran.id;

        this.setState({ ...this.state, showSpinner: true }, () => {

            putData(url, (response) => {

                this.setState({ ...this.state, showSpinner: false });

                this.props.hideDialog();

                if (this.props.refreshHandler !== undefined) this.props.refreshHandler();

                this.props.openDialog(
                    'SimpleMessage',
                    {
                        message: 'Albaran cerrado',
                    },
                    'cerrar_albaran_hist_success',
                    false,
                    'sm',
                );

            }, (error) => {
                this.props.openDialog(
                    'SimpleMessage',
                    {
                        message: 'Error cerrando albaran',
                    },
                    'cerrar_albaran_hist_error',
                    false,
                    'sm',
                );

                this.setState({ ...this.state, showSpinner: false });

            }, {}, this.props.user, false);
        });
    }


    render() {
        const { classes } = this.props;

        if (this.state.showSpinner === true)
            return (
                <div className={classes.spinnerContainer}>
                    <CircularProgress
                        className={classes.spinner}
                        color="primary"
                    />
                </div>
            );
        else {
            if (this.state.albaran && this.state.albaran.lLineas)
                this.state.albaran.lLineas.forEach(p => {
                    if (p.iCantidadPendiente === 0) {
                        p.iCantidadPendiente = null;
                        p.cantidad = null;
                    }
                });

            const { classes } = this.props;

            const grColumns = (this.props.imenu === "1") ?
                [
                    { key: 'articuloDescr', name: 'Artículo', editable: false, dragable: false, width: 300, grayField: 'colColorTrue', },
                    { key: 'puntos', name: 'Puntos', type: 'int', editable: false, dragable: false, width: 60, grayField: 'colColorTrue', },
                    { key: 'codBarras', name: 'Cód. Barras', editable: true, dragable: false, width: 150, },
                    {
                        key: 'iCantidadPendiente', editable: false, dragable: false, type: 'int', width: 60, grayField: 'colColorTrue',
                        name: 'Ud.Pdte.',
                        tooltip: 'Número de unidades pendientes de recibir'
                    },
                    {
                        key: 'cantidad', editable: this.props.iPerfil !== 22, dragable: false, type: 'int', width: 60,
                        name: 'Ud.Recib.',
                        tooltip: 'Número de unidades recibidas'
                    },
                    { key: 'articuloCod', name: 'Cód.Art.', editable: false, dragable: false, width: 60, grayField: 'colColorTrue', },
                ]
                :
                [
                    { key: 'articuloDescr', name: 'Artículo', editable: false, dragable: false, width: 300 },
                    {
                        key: 'cantidad', editable: this.props.iPerfil !== 22, dragable: false, type: 'int', width: 60,
                        name: 'Ud.Recib.',
                        tooltip: 'Número de unidades recibidas'
                    },
                    // { key: 'tarifa', name: 'Tarifa', type: 'float', editable: false, dragable: false, width: 60 },
                    { key: 'puntos', name: 'Puntos', type: 'int', editable: false, dragable: false, width: 60 },
                    { key: 'precio', name: 'Precio', type: 'float', editable: false, dragable: false, width: 60 },
                    { key: 'total', name: 'Total', type: 'float', editable: false, dragable: false, width: 60 },
                    { key: 'articuloCod', name: 'Cód.Art.', editable: false, dragable: false, width: 60 },
                ];

            return (
                <div className={classes.root}>
                    <div style={{ marginBottom: 20 }}>
                        <div className={classes.margin} containerPair>
                            <Typography variant="h6" className={classes.title} color={'primary'}>
                                {'Centro: ' + (this.props.kd === undefined ?  this.props.centroDescr : this.props.kd.empresa)}
                            </Typography>
                        </div>
                        <div className={classes.containerPair}>
                            <Typography variant="body1" className={classes.title} color={'secondary'}>
                                {'Fecha pedido: ' + this.props.pedido.fDoc.slice(0, 10)}
                            </Typography>
                            <Typography variant="body2" className={classes.title} color={'secondary'}>
                                {'Proveedor: ' + this.props.pedido.proveedorDescr}
                            </Typography>
                        </div>
                        <div className={classes.containerPair}>
                            <Typography variant="body1" className={classes.title} color={'secondary'}>
                                {'Documento: ' + this.props.pedido.refPedido}
                            </Typography>
                            <Typography variant="body2" className={classes.title} color={'secondary'}>
                                {'Obsv: ' + this.props.pedido.obsv}
                            </Typography>
                        </div>
                    </div>
                    <div>
                        <div className={classes.margin}>
                            <Typography variant="h6" className={classes.title} color={'primary'} >
                                Albarán
                            </Typography>
                        </div>
                        <div className={classes.containerPair}>
                            {(this.props.imenu === "1") ?
                                <FormControl className={classes.formControl}>
                                    <TextField
                                        id={'refAlbaran'}
                                        label={'Ref. Albaran'}
                                        placeholder={'Ref. Albaran'}
                                        margin="normal"
                                        value={this.state.a_refAlbaran}
                                        onChange={event =>
                                            this.handleValueChange(
                                                event,
                                                'a_refAlbaran',
                                            )
                                        }
                                    />
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={this.state.a_iTipoAlbaran==1 ? true : false}
                                    onChange={e => this.handleCheckboxNumber(e, 'a_iTipoAlbaran')}
                                />
                            }
                            label="Devolución"
                        />
                                </FormControl>
                                :
                                <Typography variant="body1" className={classes.title} color={'primary'} >
                                    {'Ref Albaran: ' + this.state.albaran.refAlbaran}
                                </Typography>
                            }
                            {(this.props.imenu === "1" || this.state.albaran.bCerrado === false) ?
                                <FormControl className={classes.formControl}>
                                    <DatePicker
                                        label={'Fecha Entrega'}
                                        value={this.state.a_fEntrega}
                                        onChange={event => {
                                            if (event && !isNaN(event)) {
                                                const d = new Date(Date.UTC(event.getFullYear(), event.getMonth(), event.getDate()));
                                                this.handleValueChangeDate(
                                                    d.toISOString().slice(0, 10),
                                                    'a_fEntrega',
                                                )
                                            }
                                        }}
                                    />
                                </FormControl>
                                :
                                <Typography variant="body1" className={classes.title} color={'primary'} >
                                    {'   Fecha Entrega: ' + new Date(this.state.albaran.fEntrega).toLocaleDateString('es-ES', { year: '2-digit', month: '2-digit', day: '2-digit' })}
                                </Typography>
                            }
                            {(this.props.imenu === "1") ?
                                <FormControl className={classes.formControl}>
                                    <TextField
                                        id={'obsv'}
                                        label={'Observacions'}
                                        placeholder={'Observaciones'}
                                        value={this.state.a_obsv}
                                        onChange={event =>
                                            this.handleValueChange(event, 'a_obsv')
                                        }
                                    />
                                </FormControl>
                                :
                                <Typography variant="body1" className={classes.title} color={'primary'} >
                                    {'   Observaciones: ' + this.state.albaran.obsv}
                                </Typography>
                            }
                        </div>
                    </div>

                    <div style={{ marginBottom: 20 }}>
                        {this.state.albaran && this.state.albaran.lLineas ? (
                            <NeuriteGrid
                                id="e_n_a"
                                columns={grColumns}
                                rows={this.state.albaran.lLineas}
                                height={300}
                                buttonEdit={false}
                                buttonDelete={false}
                                buttonNew={false}
                                onRowsUpdated={this.handleGridRowsUpdated}
                                enableFilter={true}
                            />
                        ) : (
                                ''
                            )}
                    </div>

                    <div className={classes.containerPair}>
                        <TextField
                            id="outlined-read-only-input-uds"
                            label="Total Uds."
                            style={{ marginRight: "20px" }}
                            value={this.state.tot_uds}
                            InputProps={{ classes: { input: classes.inputElementRight }, readOnly: true }}
                            variant="outlined"
                        />
                        <TextField
                            id="outlined-read-only-input-total"
                            label="Total €"
                            style={{ marginRight: "20px" }}
                            value={this.state.tot_albaran}
                            variant="outlined"
                            InputProps={{
                                classes: { input: classes.inputImporte },
                                inputComponent: FloatNumberFormatInput,
                                readOnly: true,
                            }}
                        />
                    </div>

                    <div className={classes.buttonsContainer}>
                        <Button
                            className={classes.buttonsBottom}
                            variant="contained"
                            color="secondary"
                            onClick={() => this.props.hideDialog()}
                        >
                            Atrás
                        </Button>
                        {(this.props.imenu === "1") ?
                            <Button
                                hidden={[16, 17, 22].includes(this.props.iPerfil)}
                                className={classes.buttonsBottom}
                                variant="contained"
                                color="primary"
                                onClick={() => this.nuevoAlbaran_hideDialog()}
                            >
                                Guardar
                            </Button>
                            :
                            <Button
                                className={classes.buttonsBottom}
                                variant="contained"
                                color="primary"
                                onClick={() => this.imprimir()}
                            >
                                Imprimir
                            </Button>
                        }
                        {(this.props.imenu !== "1") && this.state.albaran.bCerrado === false ?
                            <Button
                                hidden={[15, 16, 17, 22].includes(this.props.iPerfil)}
                                className={classes.buttonsBottom}
                                variant="contained"
                                color="primary"
                                onClick={() => this.actualizarAbaran_hideDialog()}
                            >
                                Guardar
                            </Button>

                            : ''
                        }
                        {(this.props.imenu !== "1") && this.state.albaran.bCerrado === false ?
                            <Button
                                hidden={[15, 16, 17, 22].includes(this.props.iPerfil)}
                                className={classes.buttonsBottom}
                                variant="contained"
                                color="primary"
                                onClick={() => this.cerrarAbaran_hideDialog()}
                            >
                                Cerrar
                            </Button>

                            : ''
                        }
                        {(this.props.imenu !== "1") && [0, 4, 5, 15, 17, 20].includes(this.props.iPerfil) && this.state.albaran.bCerrado === true ?
                            <Button
                                className={classes.buttonsBottom}
                                variant="contained"
                                color="primary"
                                onClick={() => this.abrirAlbaran()}
                            >
                                Abrir
                            </Button>
                            : ''
                        }

                        {(this.props.imenu !== "1") && [0, 4, 5, 17, 20].includes(this.props.iPerfil) && this.state.albaran.bCerrado !== true ?
                            <Button
                                className={classes.buttonsBottom}
                                variant="contained"
                                color="primary"
                                onClick={() => this.borrarAlbaran()}
                            >
                                Borrar albaran
                            </Button>
                            : ''
                        }
                    </div>
                </div>
            );
        }
    }

}

EditNuevoAlbaran.propTypes = {
    pedido: PropTypes.object.isRequired,
    imenu: PropTypes.string.isRequired,
    centroId: PropTypes.number.isRequired,
    okHandler: PropTypes.func.isRequired,
    refreshHandler: PropTypes.func.isRequired,
    hideDialog: PropTypes.func.isRequired,
    user: PropTypes.object.isRequired,
    iPerfil: PropTypes.number.isRequired
};

export default withStyles(styles, { withTheme: true })(EditNuevoAlbaran);
